// extracted by mini-css-extract-plugin
export default {"header":"MainPanel_header__F83jn","gradient":"MainPanel_gradient__3ZDKb"};